import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/no-img.png';
import _imports_1 from '../../assets/日期.png';
const _withScopeId = n => (_pushScopeId("data-v-56ff5744"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container ActiveDetail"
};
const _hoisted_2 = {
  class: "header header3"
};
const _hoisted_3 = {
  class: "header-box"
};
const _hoisted_4 = {
  key: 0,
  class: "data-item"
};
const _hoisted_5 = {
  class: "num",
  style: {
    "color": "#7585a2"
  }
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "应活跃", -1));
const _hoisted_7 = {
  key: 1,
  class: "line"
};
const _hoisted_8 = {
  class: "data-item"
};
const _hoisted_9 = {
  class: "num",
  style: {
    "color": "#f7c739"
  }
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "已活跃", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_12 = {
  class: "data-item"
};
const _hoisted_13 = {
  class: "num",
  style: {
    "color": "#a285d2"
  }
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "活跃完成", -1));
const _hoisted_15 = {
  key: 2,
  class: "line"
};
const _hoisted_16 = {
  key: 3,
  class: "data-item"
};
const _hoisted_17 = {
  class: "num",
  style: {
    "color": "#8fd065"
  }
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "活跃合格", -1));
const _hoisted_19 = {
  class: "daylist"
};
const _hoisted_20 = {
  class: "bottom-box"
};
const _hoisted_21 = {
  class: "filters"
};
const _hoisted_22 = {
  class: "filtersbox"
};
const _hoisted_23 = {
  class: "filtersarrow"
};
const _hoisted_24 = {
  key: 0,
  class: "store-list"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "no-img-wrap"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "no-img",
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createTextVNode(" 暂无图片 ")], -1));
const _hoisted_27 = {
  class: "store-info"
};
const _hoisted_28 = {
  class: "store-name"
};
const _hoisted_29 = {
  class: "name"
};
const _hoisted_30 = {
  key: 0,
  class: "status status1"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icoday"
}, null, -1));
const _hoisted_32 = {
  key: 1,
  class: "status status2"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icoday2"
}, null, -1));
const _hoisted_34 = {
  key: 2,
  class: "status status2"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icoday3"
}, null, -1));
const _hoisted_36 = {
  class: "location"
};
const _hoisted_37 = {
  class: "text-list"
};
const _hoisted_38 = {
  class: "text-item"
};
const _hoisted_39 = {
  class: "label"
};
const _hoisted_40 = {
  class: "text-item"
};
const _hoisted_41 = {
  class: "label"
};
const _hoisted_42 = {
  class: "text-item"
};
const _hoisted_43 = {
  class: "label"
};
const _hoisted_44 = {
  key: 0,
  style: {
    "color": "red"
  },
  class: "label"
};
const _hoisted_45 = {
  key: 1,
  style: {
    "color": "red"
  },
  class: "label"
};
const _hoisted_46 = {
  class: "text-item"
};
const _hoisted_47 = {
  class: "label"
};
const _hoisted_48 = {
  key: 0,
  style: {
    "color": "red"
  },
  class: "label"
};
const _hoisted_49 = {
  key: 1,
  style: {
    "color": "red"
  },
  class: "label"
};
const _hoisted_50 = {
  key: 2,
  style: {
    "color": "red"
  },
  class: "label"
};
const _hoisted_51 = {
  class: "header header2"
};
const _hoisted_52 = {
  class: "content"
};
const _hoisted_53 = {
  class: "upbox"
};
const _hoisted_54 = {
  class: "contentup"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "预计活跃数量", -1));
const _hoisted_56 = {
  class: "num",
  style: {
    "color": "#faad14",
    "margin-left": "0.19rem"
  }
};
const _hoisted_57 = {
  class: "contentup"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "活跃获取", -1));
const _hoisted_59 = {
  class: "num",
  style: {
    "color": "#1890ff",
    "margin-left": "0.19rem"
  }
};
const _hoisted_60 = {
  class: "downbox"
};
const _hoisted_61 = {
  class: "contentdown"
};
const _hoisted_62 = {
  class: "downinbox"
};
const _hoisted_63 = {
  class: "num1",
  style: {
    "color": "#52c41a"
  }
};
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "合格", -1));
const _hoisted_65 = {
  class: "downinbox",
  style: {
    "padding-right": "0.1rem"
  }
};
const _hoisted_66 = {
  class: "num1",
  style: {
    "color": "#52c41a"
  }
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "合格率", -1));
const _hoisted_68 = {
  class: "contentdown2"
};
const _hoisted_69 = {
  class: "downinbox1"
};
const _hoisted_70 = {
  class: "num1",
  style: {
    "color": "#ff4d4f"
  }
};
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "异常", -1));
const _hoisted_72 = {
  class: "downinbox2"
};
const _hoisted_73 = {
  class: "lastin"
};
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "位置偏差", -1));
const _hoisted_75 = {
  class: "num2",
  style: {
    "margin-left": "0.28rem"
  }
};
const _hoisted_76 = {
  class: "lastin",
  style: {
    "margin-top": "0.1rem"
  }
};
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "未结束", -1));
const _hoisted_78 = {
  class: "num2",
  style: {
    "margin-left": "0.48rem"
  }
};
const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "foot"
}, "以上统计结果不包含已取消计划", -1));
const _hoisted_80 = {
  key: 0,
  class: "list"
};
const _hoisted_81 = ["onClick"];
const _hoisted_82 = {
  class: "info-item"
};
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-items"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "icon"
})], -1));
const _hoisted_84 = {
  class: "textitem1"
};
const _hoisted_85 = {
  class: "info-date"
};
const _hoisted_86 = {
  class: "cntitem1"
};
const _hoisted_87 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "textitem"
}, "活跃获取", -1));
const _hoisted_88 = {
  class: "info-date"
};
const _hoisted_89 = {
  class: "cntitem2"
};
const _hoisted_90 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "textitem"
}, "活跃合格", -1));
const _hoisted_91 = {
  class: "bottombtn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_search = _resolveComponent("van-search");
  const _component_Selector = _resolveComponent("Selector");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_image = _resolveComponent("van-image");
  const _component_lazy_component = _resolveComponent("lazy-component");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_picker = _resolveComponent("van-picker");
  const _component_van_tabs = _resolveComponent("van-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_tabs, {
    active: $data.activeName,
    "onUpdate:active": _cache[14] || (_cache[14] = $event => $data.activeName = $event),
    "title-active-color": "#3875C6",
    "title-inactive-color": "#666",
    color: "#3875C6",
    "line-width": "3.35rem",
    class: "custom-tabs"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tab, {
      title: "单日",
      name: "日",
      "title-class": "titletab",
      "title-style": "font-size: .28rem;line-height: 0.36rem;font-weight: 600;"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_field, {
        modelValue: $data.result1,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.result1 = $event),
        "is-link": "",
        readonly: "",
        label: "日期",
        onClick: _cache[1] || (_cache[1] = $event => $data.showPicker = true)
      }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
        show: $data.showPicker,
        "onUpdate:show": _cache[3] || (_cache[3] = $event => $data.showPicker = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_datetime_picker, {
          type: "date",
          title: "选择日期",
          "min-date": $data.minDate,
          "max-date": $data.maxDate,
          onCancel: _cache[2] || (_cache[2] = $event => $data.showPicker = false),
          onChange: $options.onchange1,
          onConfirm: $options.onConfirm1
        }, null, 8, ["min-date", "max-date", "onChange", "onConfirm"])]),
        _: 1
      }, 8, ["show"]), _createElementVNode("div", _hoisted_3, [$data.listDataDay.projectCategory === 'DP' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($data.listDataDay.attExpect), 1), _hoisted_6])) : _createCommentVNode("", true), $data.listDataDay.projectCategory === 'DP' ? (_openBlock(), _createElementBlock("div", _hoisted_7)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString($data.listDataDay.attDay), 1), _hoisted_10]), _hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString($data.listDataDay.attCount), 1), _hoisted_14]), $data.listDataDay.projectCategory === 'LHDG' ? (_openBlock(), _createElementBlock("div", _hoisted_15)) : _createCommentVNode("", true), $data.listDataDay.projectCategory === 'LHDG' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString($data.listDataDay.attPassCount), 1), _hoisted_18])) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: "header-button",
        onClick: _cache[4] || (_cache[4] = (...args) => $options.goActiveStatistics && $options.goActiveStatistics(...args))
      }, "查看地区维度统计结果")]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_van_search, {
        modelValue: $data.searchname,
        "onUpdate:modelValue": [_cache[5] || (_cache[5] = $event => $data.searchname = $event), $options.updatesearch],
        shape: "round",
        placeholder: "终端名称模糊查找"
      }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_Selector, {
        class: "selector first",
        value: $data.status,
        "onUpdate:value": _cache[6] || (_cache[6] = $event => $data.status = $event),
        options: $options.filterStatusList,
        title: "类型",
        onChange: $options.getData1
      }, null, 8, ["value", "options", "onChange"]), _createVNode(_component_Selector, {
        class: "selector",
        value: $data.province,
        "onUpdate:value": _cache[7] || (_cache[7] = $event => $data.province = $event),
        options: $data.provinceList,
        title: "省",
        onChange: $options.getCity
      }, null, 8, ["value", "options", "onChange"]), _createVNode(_component_Selector, {
        class: "selector",
        value: $data.city,
        "onUpdate:value": _cache[8] || (_cache[8] = $event => $data.city = $event),
        options: $data.cityList,
        title: "市",
        onChange: $options.getArea
      }, null, 8, ["value", "options", "onChange"]), _createVNode(_component_Selector, {
        class: "selector",
        value: $data.area,
        "onUpdate:value": _cache[9] || (_cache[9] = $event => $data.area = $event),
        options: $data.areaList,
        title: "区",
        onChange: $options.getData1
      }, null, 8, ["value", "options", "onChange"])]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_van_icon, {
        name: "arrow"
      })])]), $data.listData.length ? (_openBlock(), _createElementBlock("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.listData, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "store-item",
          key: index,
          onClick: $event => $options.implementationDetail(item)
        }, [_createVNode(_component_lazy_component, null, {
          default: _withCtx(() => [_createVNode(_component_van_image, {
            class: "store-img",
            "lazy-load": "",
            src: item.url || 'fake-img',
            onError: $event => $options.getPhotos(item)
          }, {
            error: _withCtx(() => [_hoisted_26]),
            _: 2
          }, 1032, ["src", "onError"])]),
          _: 2
        }, 1024), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(item.terminalName) + " ", 1), item.status === 'atting' ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_hoisted_31, _createTextVNode(" 活跃中 ")])) : _createCommentVNode("", true), item.status === 'att_fail' ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_hoisted_33, _createTextVNode(" 活跃异常 ")])) : _createCommentVNode("", true), item.status === 'no_att' ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_hoisted_35, _createTextVNode(" 未活跃 ")])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_36, _toDisplayString(item.province) + _toDisplayString(item.city) + _toDisplayString(item.area), 1), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("span", _hoisted_39, "任务：" + _toDisplayString(item.posName), 1)]), _createElementVNode("div", _hoisted_40, [_createElementVNode("span", _hoisted_41, "触点姓名：" + _toDisplayString(item.pgName), 1)]), _createElementVNode("div", _hoisted_42, [_createElementVNode("span", _hoisted_43, "开始时间：" + _toDisplayString(item.attStart ? item.attStart : '--:--'), 1), item.startStatus === 1 && item.status !== 'no_att' ? (_openBlock(), _createElementBlock("span", _hoisted_44, " （ ≥ 800m 位置偏离 ） ")) : _createCommentVNode("", true), item.startStatus >= 2 && item.status !== 'no_att' ? (_openBlock(), _createElementBlock("span", _hoisted_45, " （ GPS获取异常 ） ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_46, [_createElementVNode("span", _hoisted_47, "结束时间：" + _toDisplayString(item.attEnd ? item.attEnd : '--:--'), 1), item.status !== 'atting' && item.endStatus === null && item.status !== 'no_att' ? (_openBlock(), _createElementBlock("span", _hoisted_48, " （ 无 ） ")) : _createCommentVNode("", true), item.endStatus === 1 && item.status !== 'no_att' ? (_openBlock(), _createElementBlock("span", _hoisted_49, " （ ≥ 800m 位置偏离 ） ")) : _createCommentVNode("", true), item.endStatus >= 2 && item.status !== 'no_att' ? (_openBlock(), _createElementBlock("span", _hoisted_50, " （ GPS获取异常 ） ")) : _createCommentVNode("", true)])])])], 8, _hoisted_25);
      }), 128))])) : (_openBlock(), _createBlock(_component_van_empty, {
        key: 1,
        description: "暂无数据"
      }))])])]),
      _: 1
    }), _createVNode(_component_van_tab, {
      title: "周",
      name: "周",
      "title-class": "titletab",
      "title-style": "font-size: .28rem;line-height: 0.36rem;font-weight: 600;"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_51, [_createVNode(_component_van_field, {
        modelValue: $data.result,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.result = $event),
        "is-link": "",
        readonly: "",
        label: "日期区间",
        onClick: _cache[11] || (_cache[11] = $event => $data.showPicker = true)
      }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
        show: $data.showPicker,
        "onUpdate:show": _cache[13] || (_cache[13] = $event => $data.showPicker = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          columns: $data.weeklist,
          onCancel: _cache[12] || (_cache[12] = $event => $data.showPicker = false),
          onConfirm: $options.onConfirm
        }, null, 8, ["columns", "onConfirm"])]),
        _: 1
      }, 8, ["show"]), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_hoisted_55, _createElementVNode("span", _hoisted_56, _toDisplayString($data.listDataWeek.weekPlanAtt), 1)]), _createElementVNode("div", _hoisted_57, [_hoisted_58, _createElementVNode("span", _hoisted_59, _toDisplayString($data.listDataWeek.weekAtt), 1)])]), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, _toDisplayString($data.listDataWeek.weekPassAtt), 1), _hoisted_64]), _createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, _toDisplayString($data.listDataWeek.weekPassAttRate) + "%", 1), _hoisted_67])]), _createElementVNode("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, _toDisplayString($data.listDataWeek.weekFailAtt), 1), _hoisted_71]), _createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_hoisted_74, _createElementVNode("div", _hoisted_75, _toDisplayString($data.listDataWeek.weekFailGpsAtt), 1)]), _createElementVNode("div", _hoisted_76, [_hoisted_77, _createElementVNode("div", _hoisted_78, _toDisplayString($data.listDataWeek.weekFailEndAtt), 1)])])])])]), _hoisted_79]), _createElementVNode("div", null, [$data.listDataWeek.dayAtt ? (_openBlock(), _createElementBlock("div", _hoisted_80, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.listDataWeek.dayAtt, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item,
          class: "listitem",
          onClick: $event => $options.godate(item.date)
        }, [_createElementVNode("div", _hoisted_82, [_hoisted_83, _createElementVNode("div", _hoisted_84, "   " + _toDisplayString(item.date.slice(5)), 1)]), _createElementVNode("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, _toDisplayString(item.dayAtt), 1), _hoisted_87]), _createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, _toDisplayString(item.dayPassAtt), 1), _hoisted_90])], 8, _hoisted_81);
      }), 128))])) : (_openBlock(), _createBlock(_component_van_empty, {
        key: 1,
        description: "暂无数据"
      }))])]),
      _: 1
    })]),
    _: 1
  }, 8, ["active"]), _createElementVNode("div", _hoisted_91, [_createElementVNode("button", {
    class: "btn1",
    onClick: _cache[15] || (_cache[15] = (...args) => $options.goback && $options.goback(...args))
  }, "返回")])]);
}